import React, { useState, useRef, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import no_content from "../assets/home/did-you-know-no-result.svg";

const NoDidyouKnow = () => {

    const { t, i18n } = useTranslation();


  return (
    <div className='NoDidyouKnow'>
        <img src={no_content} />
        <h3>No Did You Know</h3>
          <h5>Lorem ipsum dolor sit amet, consectetur </h5>
        
        
        
        </div>
  )
}

export default NoDidyouKnow